import { createSlice } from '@reduxjs/toolkit'
import { customSortWithOrderBy } from 'src/utils'
import { isEmpty } from 'lodash'
import { fetchUrl } from './thunk'

const initialState = {
  fetchUrlData: [],
  fetchUrlDataIsLoading: false,
  fetchUrlDataError: undefined,

  selectedItemsIds: [],
}

const slice = createSlice({
  name: 'fetchTableResults',
  initialState,
  reducers: {
    clearFetchUrlData(state) {
      state.fetchUrlData = []
    },
    setSelectedItemsIds(state, { payload }) {
      if (state.selectedItemsIds.includes(payload[0])) {
        state.selectedItemsIds = []
        // return prevSelectedItemsIds.filter((element) => element !== itemId);
      } else {
        // Array.isArray(payload1) ? payload1 : [payload1]
        state.selectedItemsIds = payload
        // return [...prevSelectedItemsIds, itemId];
      }
    },
    setSelectedForPassportItemsIds(state, { payload }) {
      state.selectedItemsIds = payload
    },
    clearSelectedIds(state) {
      state.selectedItemsIds = []
    },

    filterByDeliveryTransportId(state, { payload }) {
      if (state.fetchUrlData.data) {
        state.fetchUrlData.data = state.fetchUrlData.data.filter(
          ({ clientAddress: { lastMileDeliveryMethod: { id } = {} } = {} }) =>
            id === payload.deliveryTransportId
        )
      } else if (state.fetchUrlData.content) {
        state.fetchUrlData.content = state.fetchUrlData.content.filter(
          ({ clientAddress: { lastMileDeliveryMethod: { id } = {} } = {} }) =>
            id === payload.deliveryTransportId
        )
      }
    },

    updateItem(state, { payload }) {
      const replaceItem = (items) =>
        items.map((item) => (item.id === payload.id ? payload : item))

      if (state.fetchUrlData.data) {
        state.fetchUrlData.data = replaceItem(state.fetchUrlData.data)
      } else if (state.fetchUrlData.content) {
        state.fetchUrlData.content = replaceItem(state.fetchUrlData.content)
      }
    },

    sortTableResultsData(state, { payload }) {
      const hasDataProp = Object.prototype.hasOwnProperty.call(
        state.fetchUrlData,
        'data'
      )
      const hasContentProp = Object.prototype.hasOwnProperty.call(
        state.fetchUrlData,
        'content'
      )
      let fetchedData = {}

      if (hasDataProp) {
        fetchedData = state.fetchUrlData.data
      } else if (hasContentProp) {
        fetchedData = state.fetchUrlData.content
      }

      if (isEmpty(fetchedData)) return

      const { orderBy, ascOrDesc } = payload || {}

      const sortedData = customSortWithOrderBy(fetchedData, orderBy, ascOrDesc)

      if (hasDataProp) {
        state.fetchUrlData = { ...state.fetchUrlData, data: sortedData }
      } else if (hasContentProp) {
        state.fetchUrlData = {
          ...state.fetchUrlData,
          content: sortedData,
        }
      } else {
        state.fetchUrlData = {}
      }
    },
  },
  extraReducers: {
    [fetchUrl.pending]: (state) => {
      state.fetchUrlDataIsLoading = true
    },
    [fetchUrl.fulfilled]: (state, action) => {
      state.fetchUrlDataIsLoading = false
      state.fetchUrlData = action.payload
    },
    [fetchUrl.rejected]: (state, { payload }) => {
      state.fetchUrlDataIsLoading = false
      state.fetchUrlDataError = payload
    },
  },
})

export const {
  clearFetchUrlData,
  setSelectedItemsIds,
  setSelectedForPassportItemsIds,
  clearSelectedIds,
  filterByDeliveryTransportId,
  sortTableResultsData,
  updateItem,
} = slice.actions

export const reducer = slice.reducer
export const selectorFetchTableResults = (state) => state[slice.name]
export default slice
